import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-secrets-add-edit',
  templateUrl: './add-edit.component.html',
  styleUrls: ['./add-edit.component.scss']
})
export class SecretsAddEditComponent implements OnInit {

  @Input() object: any;
  @Input() key: any;
  @Input() extraData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
